<template>
  <v-tooltip bottom content-class="engine-tooltip">
    <template #activator="{ on, attrs }">
      <!-- span wrapper required so hover fires even when button is disabled -->
      <span v-bind="attrs" v-on="on">
        <v-btn
          depressed
          :loading="recalculatingAll"
          :disabled="!canRecalculateAll"
          :class="[
            'refresh-button',
            `${hasUnsavedKpiResults ? 'unsaved-kpis' : ''}`,
            `${hideText ? '' : 'with-text'}`,
          ]"
          data-dd-action-name="Recalculate all"
          @click="runEngineForAllScenarios"
        >
          <span v-if="!hideText">{{ $t('actions.recalculateAll') }}</span>
          <cog-play-icon />
        </v-btn>
      </span>
    </template>
    <div>{{ $t('gridView.tooltips.strategicOptimiser') }}</div>
    <template v-if="recalculateAllButtonBlockedMsg">
      <v-divider class="my-2" dark />
      <div>{{ recalculateAllButtonBlockedMsg }}</div>
    </template>
  </v-tooltip>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  props: {
    unsavedKpiResults: {
      type: Boolean,
      default: false,
    },
    hideText: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('gridView', [
      'calculatingScenarioResults',
      'recalculatingAll',
      'calculatingScenarioElasticityResults',
    ]),
    ...mapGetters('gridView', ['hasUnsavedKpiResultsForWorkpackage']),
    ...mapGetters('context', ['isWholesaleManager', 'isWholesaleAnalyst', 'isAdminLoggedIn']),

    canRecalculateAll() {
      return (
        this.isEditable &&
        !this.calculatingScenarioResults &&
        !this.recalculatingAll &&
        !this.calculatingScenarioElasticityResults
      );
    },

    recalculateAllButtonBlockedMsg() {
      if (this.hasUnsavedKpiResults) {
        return this.$t('gridView.tooltips.hasUnsavedKpiResults');
      }
      if (this.calculatingScenarioElasticityResults) {
        return this.$t('gridView.tooltips.crossElasticityOptimisationRunning');
      }
      if (this.calculatingScenarioResults || this.recalculatingAll) {
        return this.$t('gridView.tooltips.engineRunning');
      }
      return '';
    },

    isEditable() {
      return this.isAdminLoggedIn || (!this.isWholesaleManager && !this.isWholesaleAnalyst);
    },

    hasUnsavedKpiResults() {
      // Check for root level unsaved kpi results from store if not received as a param
      return this.unsavedKpiResults || this.hasUnsavedKpiResultsForWorkpackage;
    },
  },

  async created() {
    await this.checkRecalculatingAll();
  },

  methods: {
    ...mapActions('context', ['logout', 'resetState']),
    ...mapActions('gridView', ['runEngineForAllScenarios', 'checkRecalculatingAll']),
  },
};
</script>

<style scoped lang="scss">
@import '@style/base/_variables.scss';

.refresh-button {
  background-color: $pricing-primary !important;
  color: $pricing-white;
  min-width: unset !important;
  padding: unset !important;
  height: 3rem !important;
  width: 3rem;

  // When showing text (main-navbar usage), restore a wider layout
  &.with-text {
    width: 140px !important;
    height: 24px !important;
    // avoid rem, want button to be exactly the same regardless of parent container
    font-size: 14px !important;
    padding: initial !important;
    min-width: initial !important;
  }

  &.unsaved-kpis {
    background-color: $pricing-orange !important;

    &.theme--light.v-btn.v-btn--disabled:not(.v-btn--loading) {
      background-color: $pricing-orange !important;
    }
  }
}
</style>
